<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <div class="row flex-flow-column">
          <div class="col">
            <p>{{ $t("markUpNew.title") }}</p>
          </div>

          <p class="desc">{{ $t("markUpNew.desc") }}</p>
        </div>
      </CCardHeader>
      <ValidationObserver v-slot="{ handleSubmit }">
        <!-- <form @submit.prevent="handleSubmit(toSaveSupplierGrp)"> -->
          <CCardBody class="card assign pricing-card m-auto">
             <div class="row flex-flow-column">
              <div class="col">
                <h4><strong>{{ $t("markUpNew.markup") }}</strong></h4>
              </div>
            </div>
            <div class="max-w-850">
              <div class="row mt-20px mb-20px">
                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class>

                    <div class='row'>
                      <cStatusButton v-if="GET_SEL_MARKUP"
                      
                      class="generate-ex-btn label-margin-unset"
                    :isConfirm="true"
                    :buttonDesc=" $t('markUpNew.statusDesc')"
                    :defaultStatus.sync="markup.isActive"
                    @change="onMarkupStatusChange"
                    :label="{checked: $t('markUpNew.active'), unchecked: $t('markUpNew.inactive')}">

                      </cStatusButton>
                    </div>
                    <div class="row">
                      <div class="col-7">
                        <label>{{ $t("markUpNew.supplier") }}</label>
                        <div class>
                          <ValidationProvider
                            class="w-100"
                            tag="div"
                            rules="required"
                            v-slot="{ errors }"
                          >

                            <multiselect
                              :disabled='GET_SEL_MARKUP?true:false'
                              :searchable="true"
                              :close-on-select="true"
                              :track-by="'id'"
                              :label="'name'"
                              :allow-empty="false"
                              v-model="markup.supplier"
                              @input="onSupplierGroupChange"
                              :show-labels="false"
                              :options="lsSupplierGroup"
                              :placeholder="$t('markUpNew.suppPlc')"
                            >
                             <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                            </multiselect>
                            <div
                              v-if="errors && errors[0]"
                              class="invalid-feedback icon"
                            >
                              <span>{{ errors[0] }}</span>
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class="row">
                    <div class="col-12">
                      <label>{{ $t("markUpNew.hotel") }}</label>
                      <div class>
                        <ValidationProvider
                          class="w-100"
                          tag="div"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <multiselect
                            :searchable="true"
                            :close-on-select="true"
                            :track-by="'hotelid'"
                            :label="'hotelName'"
                            :allow-empty="false"
                            v-model="markup.hotel"
                            :show-labels="false"
                            :options="lsHotels"
          
                            v-on:input="onHotelChange"
                            :placeholder="'Select Hotel'"
                          >

                            <template #noOptions>
                              <div>
                                     <span slot="noResult"><strong>
                              {{
                              
                              markup.supplier?
                               $t("noMatchFound.noMatchFound"):$t('markUpNew.noSupplier') }}</strong></span>

                              </div>
                            </template>
                            <span slot="noResult"><strong>
                              {{
                              
                              markup.supplier?
                               $t("noMatchFound.noMatchFound"):$t('markUpNew.noSupplier') }}</strong></span>
                          </multiselect>
                          <div
                            v-if="errors && errors[0]"
                            class="invalid-feedback icon"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class="row">
                    <div class="col-12">
                      <label>{{ $t("markUpNew.room") }}</label>
                      <div class>
                        <ValidationProvider
                          class="w-100"
                          tag="div"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <multiselect
                            :searchable="true"
                            :close-on-select="true"
                            :track-by="'roomid'"
                            :label="'roomname'"
                            :allow-empty="false"
                            v-model="markup.room"
                            :show-labels="false"
                            :options="lsRooms"
                            :placeholder="'Select Room'"
                          >
                            <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                          </multiselect>
                          <div
                            v-if="errors && errors[0]"
                            class="invalid-feedback icon"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class="row">
                    <div class="col-12">
                      <label>{{ $t("markUpNew.stayDate") }}</label>
                      <div class>
                        <div class="date w-100">
                          <div class="ext-date-wrapper w-100">
                            <v-md-date-range-picker
                              v-if="showTicketDate"
                              :autoApply="true"
                              :showYearSelect="true"
                              @change="onChangeTravelDate"
                              :allowPastPresets="false"
                                  :disableBefore="new Date().toString()"
                            >
                              <template slot="input">
                                <datePickerInput
                                  :fromDate="markup.from?markup.from:null"
                                  :toDate="markup.to?markup.to:null"
                                  :fromLabel="$t('addContract.fromLabel')"
                                  :toLabel="$t('addContract.toLabel')"
                                />
                              </template>
                            </v-md-date-range-picker>
                             <span class="input-group-btn tooltipIconAlign d-flex ai-center right-pa-icon" >  
                <img src="@imgPath/img/svg/icons/help.svg" alt=""  width="15px"  v-c-tooltip.hover="{
                              content: $t('hotelInfo.datePickerToolTip'),
                            }" >                  

              </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardBody class="card assign pricing-card m-auto">
            <div class="row flex-flow-column">
              <div class="col">
                <h4><strong>{{ $t("markUpNew.applicable") }}</strong></h4>
              </div>
            </div>
            <div class="max-w-850">
            
            <div class="d-flex align-item-center pt-15px">
              <CRow v-if="valueTypes" class="d-flex justify-content-center mob-jc-left mr-10px">
                <cRadioButton
                  v-for="Item in valueTypes"
                  class="radio-style app-radio"
                  :key="Item.code"
                  :val="Item.value"
                  :selValue="markup.valueType"
                  :value="Item.code"
                  :name="Item.name"
                  :label="Item.name"
                  rules="required"
                  @input="onValueTypeChange(Item)"
                />
              </CRow>
            </div>
            <br />
            <CRow>
               <CCol col="2"> 
                  <label>{{ $t("markUpNew.value") }}</label>
               </CCol>
               <CCol col="5" v-if="markup.valueType && markup.valueType.value==1">
                  
                    <cCurrencyDropDown
                      :selValue="markup.currency"
                      :placeHolder="'Currency'"
                      :ctrlName="'code'"
                      :ctrlCode="'code'"
                      :isShowCode="true"
                      :isMultiple="false"
                      :isSearchable="true"
                    
                      :defaultCurrencyCode="selCurrency"
                      :url="getCurrencyServiceURL()"
                      :rules="'required'"
                      v-on:input="onCurrencyChange"
                    />
                </CCol>
                  <CCol col="5">
                    <div class="input-group  flex-flow-row d-flex wrapper-prepend">
                      <div v-if="markup.currency && markup.valueType && markup.valueType.value==1"
                            class="input-group-prepend align-curr">
                            <div></div>
                            <span class="input-group-text">{{markup.currency.code}}</span>
                          </div>

                          <cTextInputComponent v-if="markup.valueType"
                            :placeholder="markup.valueType && markup.valueType.value==2?
                             $t('cHotelTaxSetup.percPh'): $t('cHotelTaxSetup.amountPh')"
                            :rules="'required|onlynumber|validDecimal' +(markup.valueType.value==2? '|max_value:100': '')"
                            v-model="markup.amount"
                            :isAmountField="true"
                            @onFocus="onRemoveCurrFormat(markup.amount)"
                            @onBlur="formatExchangeAmt(markup.amount,markup.currency)"
                          >
                          </cTextInputComponent>
                          <div class="input-group-append align-curr">
                            <div></div>

                            <span
                              v-if="markup.valueType && markup.valueType.value==2"
                              class="input-group-text"
                              >{{ "%" }}</span
                            >
                          </div>
                        </div>
                   
                  </CCol>
                
              </CRow>
            <!-- <div class="col-md-12 col-sm-12 mb-10px">
              <div class="row">
                <div class="col-12">
                  <label>{{ $t("markUpNew.daysOfWeek") }}</label>
                  <div class>
                    <button
                      :class="{ active: scheduleValue.isActive }"
                      @click.stop="onSaveSchedule(scheduleValue)"
                      v-for="(scheduleValue, index) in lsWeekly"
                      :key="index"
                      :style="{ color: scheduleValue.isActive ? 'blue' : '' }"
                      class="mr-10px min-w-45"
                    >
                      {{ scheduleValue.value }}
                    </button>
                  </div>
                </div>
              </div>
            </div> -->
             <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('markUpNew.daysOfWeek')}}</label>
                </p>
              </CCol>


              <cWeekDays :selDays='selApplicableDays'  @onDaysSelection='updateApplicableDays'>
                
              </cWeekDays>

              <!-- <div class="col">
                <div class="d-flex">
                  <div
                    class="checkbox d-flex align-item-center mr-15px"
                    v-for="(day, index) in lsWeekly"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      class="m-auto mr-10px ml-0px c-pointer"
                      :id="day.name"
                      v-on:input="updateApplicableDays(day)"
                      :checked="
                    selApplicableDays.some(
                      (val) => val.code == day.code
                    )
                  "
                    />

                    <label :for="day.name" :class="'mb-0 c-pointer'">{{day.name}}</label>
                  </div>
                </div>
                 <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow v-model="selApplicableDays"></CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                
              </div> -->
            </div>
          </div>
            </div>
          </CCardBody>
          <cAlertModal
            v-if="isShowAlertModal"
            :key="'CA' + alertCount"
            :buttonList="modalButton"
            :status="modalStatus"
            :isShowIcon="true"
            :show="isShowAlertModal"
            :desc="confirmTxt"
          ></cAlertModal>

          <CRow>
            <CAlert v-if="alertValue" show color="danger">
              <div v-if="alertValue && alertValue.hasOwnProperty('valueList')">
                <p v-for="(value, index) in alertValue.valueList" :key="index">
                  {{ value }}
                </p>
              </div>
              <div v-if="alertValue && alertValue.hasOwnProperty('codeList')">
                <span>{{ $t("cAlert.errorCode") + " : " }}</span>
                <span
                  v-for="(code, index) in alertValue.codeList"
                  :key="index"
                  >{{ code + " " }}</span
                >
              </div>
              <div v-if="alertValue && alertValue.constructor == String">
                <p>{{ alertValue }}</p>
              </div>
            </CAlert>
          </CRow>
          <CCardFooter>
            <CRow class="justify-content-end">
              <CButton
                @click="navigateToAllMarkup()"
                color="danger"
                class="action-c-btn mr-15px"
                >{{ $t("markUpNew.cancel") }}</CButton
              >
              <CButton
                col="12"
                type="submit"
                @click.prevent="handleSubmit(toSaveHotelMarkup)"
                color="success removewrap"
                class="action-c-btn mr-15px"
                >{{ GET_SEL_MARKUP?$t("markUpNew.update"):$t("markUpNew.add") }}</CButton
              >
            </CRow>
          </CCardFooter>
        <!-- </form> -->
      </ValidationObserver>
    </CCard>
  </div>
</template>
<script>
import router, { navigate, updateDataEdited } from "../../../router/index";
import cTextInputComponent from "../../../components/form/cTextInputComponent";
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider } from "vee-validate";

import apiGetCitiesforHotel from "../../../services/apiGetCitiesforHotel.js";

import {
  PATHNAME,
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  ALERT_MODAL_STATUS, DEFAULT_DROPDOWN_STATUS
} from "../../../util/constants";
import apiGetHotelRooms from "../../../services/apiGetHotelRooms";
import apiGetSupplierGroup from "../../../services/apiGetSupplierGroup.js";
import apiCreateHotelMarkup from "../../../services/apiCreateHotelMarkup";
import apiUpdateHotelMarkup from "../../../services/apiUpdateHotelMarkup";
import apiGetAllHotels from "../../../services/apiGetAllHotels";
import Logger from "../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../config/API_DATA";
import cAlertModal from "../../../components/form/cAlertModal";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  GroupByList,
  cloneData,
  cloneDeep,
} from "../../../util/util";
import BaseConfiguration from "../../../config/base.js";
import cStatusButton from "../../../components/form/cStatusButton";
import HotelDatePicker from "vue-range-datechooser";
import multiselect from "vue-multiselect";
import { isPastDate,addDays,formatDate } from "../../../util/date/dateFunctions";
import apiGetHmsAllEnums from "../../../services/apiGetHmsAllEnums";
import { ValidationObserver, localize, Validator } from "vee-validate";
import { VMdDateRangePicker } from "material-vue-date-picker";
import datePickerInput from "../../../components/datePicker/datePickerInput";
import cDropDown from "../../../components/form/cDropDown";
import cRadioButton from "../../../components/form/cRadioButton";
import { i18n } from "../../../plugins/i18n.js";
import cCurrencyDropDown from "../../../components/currency/cCurrencyDropDown.vue";
import { removeCurrFormat } from "../../../util/util";
import cWeekDays from "../../../components/form/cWeekDays"
import Vue from "vue";
export default {
  name: COMPONENT_NAME.MARKUP_NEW,
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickerInput,
    VMdDateRangePicker,
    cStatusButton,
    HotelDatePicker,
    cTextInputComponent,
    multiselect,
    cAlertModal,
    cDropDown,
    cWeekDays,
    cRadioButton,
    cCurrencyDropDown,
  },

  data: () => {
    return {
      alertValue: null,
      selCurrency: null,
      lsSupplierGroup: [],
      lsHotels: [],
      lsRooms: [],
      cityLs: [],
      lsWeekly: [],
      valueTypes: null,
      showTicketDate: true,
      markup: {
        supplier: null,
        hotel: null,
        room: null,
        from: null,
        to: null,
        valueType: null,
        currency: null,
        amount: null,
        applicableDays: null,
      },
      selApplicableDays: [],
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt: null,
      alertCount: 0,
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      GET_HOTEL_LS: "GET_HOTEL_LS",
      GET_ALL_ENUMS: "GET_ALL_ENUMS"
    }),
    ...mapGetters("sSupplierGrp", {
      GET_SUPPLIER_GRP_LS: "GET_SUPPLIER_GRP_LS",
    }),
    ...mapGetters("shmsMarkup", {
      GET_SEL_MARKUP: "GET_SEL_MARKUP",
    }),
  },
  methods: {
    ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
      SET_HOTEL_SEARCH_OBJ: "SET_HOTEL_SEARCH_OBJ",
    }),

    ...mapActions("sSupplierGrp", {
      SET_SUPPLIER_GRP_LS: "SET_SUPPLIER_GRP_LS",
    }),

    ...mapActions("shmsManage", {
      SET_HOTEL_LS: "SET_HOTEL_LS",
      SET_ALL_ENUMS:"SET_ALL_ENUMS"
    }),

    getCurrencyServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
      return SERVICE_URL.GET_CURRENCY_LIST;
    },



  async  onSupplierGroupChange(pSupplierGroup) {
        try {
          if(BaseConfiguration.isDebug) console.log("onSupplierGroupChange");
       

           if (!this.GET_HOTEL_LS) {
   
            await this.getallHotelss();
      }

          if(pSupplierGroup)
          {
               this.markup.hotel=null;
               this.lsRooms=[]
               this.markup.room=null
            let allHotels =  cloneDeep( this.GET_HOTEL_LS)

            if(allHotels && allHotels.length)
            {
          this.lsHotels = allHotels.filter(hotel=> hotel.supplierGroupId==pSupplierGroup.id)

            if(this.lsHotels && this.lsHotels.length)
            {
              this.lsHotels.unshift({hotelid:null,hotelName:DEFAULT_DROPDOWN_STATUS.ALL})
            }
            }
            else
            {
              this.lsHotels=[]
            }
         
          }
          else
          {
            throw "invalid supplier group"
          }
          
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.MARKUP_NEW,
                  "error in onSupplierGroupChange",
                  err.toString(),
                  "onSupplierGroupChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    getMinYear() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getMinYear");
        retValue = new Date().getFullYear() - 10 + "";
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in getMinYear",
          err.toString(),
          "getMinYear",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getMaxYear() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getMaxYear");
        retValue = new Date().getFullYear() + 1 + "";
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MARKUP_NEW,
          "error in getMaxYear",
          err.toString(),
          "getMaxYear",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onChangeTravelDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        //  console.error(pDateList)
        this.showTicketDate = false;
        this.markup.from = !isPastDate(pDateList[0]._d)
          ? pDateList[0]._d
          : new Date();
        this.markup.to = !isPastDate(pDateList[1]._d)
          ? pDateList[1]._d
          : new Date();
        // this.showTicketDate = true;
        let that = this;
        setTimeout(function () {
          that.showTicketDate = true;
        });
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onCurrencyChange(pCurrency) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCurrencyChange");
        this.markup.currency = pCurrency;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onCurrencyChange",
          err.toString(),
          "onCurrencyChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    formatExchangeAmt(pAmount, pCurrency) {
      if (BaseConfiguration.isDebug) console.log(" formatExchangeAmt");
      try {
        this.markup.amount = this.$options.filters.currencyFormat(
          pAmount,
          pCurrency
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in formatExchangeAmt",
          err.toString(),
          "formatExchangeAmt",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onRemoveCurrFormat(pAmount) {
      try {
        if (BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

        this.markup.amount = removeCurrFormat(pAmount);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onRemoveCurrFormat",
          err.toString(),
          "onRemoveCurrFormat",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onValueTypeChange(pValueType) {
      try {
        if (BaseConfiguration.isDebug) console.log("onValueTypeChange");
        this.markup.valueType = pValueType;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onValueTypeChange",
          err.toString(),
          "onValueTypeChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getValueTypes() {
      try {
        if (BaseConfiguration.isDebug) console.log("getValueTypes");
        this.valueTypes = [
          {
            name: this.$t("markUpNew.fixed"),
            code: "FIX",
            value: "1",
          },
          {
            name: this.$t("markUpNew.percentage"),
            code: "PERC",
            value: "2",
          },
        ];
        this.markup.valueType = this.valueTypes[0]
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in getValueTypes",
          err.toString(),
          "getValueTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignSelApplicableDays(pMarkupObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignSelApplicableDays");
        if (pMarkupObj) {
          for (let i = 0; i < pMarkupObj.applicableDays.length; i++) {
            if (this.GET_ALL_ENUMS.weekDays[pMarkupObj.applicableDays[i]]) {
              let dayObj = {
                name: this.GET_ALL_ENUMS.weekDays[pMarkupObj.applicableDays[i]],
                code: pMarkupObj.applicableDays[i]
              };
              this.selApplicableDays.push(dayObj);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MARKUP_NEW,
          "error in assignSelApplicableDays",
          err.toString(),
          "assignSelApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onSaveSchedule(pSchedule) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSaveSchedule");
        for (let i = 0; i <= this.lsWeekly.length; i++) {
          if (pSchedule.value == this.lsWeekly[i].value) {
            this.lsWeekly[i].isActive = !pSchedule.isActive;
            break;
          }
        }
        this.markup.applicableDays = this.saveScheduleValues(this.lsWeekly);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onSaveSchedule",
          err.toString(),
          "onSaveSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    saveScheduleValues(pLsScheduleValues) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("saveScheduleValues");
        for (let i = 0; i < pLsScheduleValues.length; i++) {
          if (pLsScheduleValues[i].isActive) {
            let day = { day: pLsScheduleValues[i].value };
            retValue.push(day);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in saveScheduleValues",
          err.toString(),
          "saveScheduleValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    onMarkupStatusChange(pStatus) {
        try {
          if(BaseConfiguration.isDebug) console.log("onMarkupStatusChange");
          this.markup.isActive=pStatus
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.MARKUP_NEW,
                  "error in onMarkupStatusChange",
                  err.toString(),
                  "onMarkupStatusChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    async onHotelChange(pHotel) {
      try {
        if (BaseConfiguration.isDebug) console.log("onHotelChange");

   let allRoom={roomid:null,roomname:DEFAULT_DROPDOWN_STATUS.ALL}
        if(pHotel && pHotel.hotelid!=null)
        {
      this.markup.room=null
     this.lsRooms = await this.getHotelRooms(pHotel);
     if(this.lsRooms && this.lsRooms.length)
     {
       this.lsRooms.unshift(allRoom)
     }
        }
        else if(pHotel && pHotel.hotelName==DEFAULT_DROPDOWN_STATUS.ALL)
        {
          this.lsRooms=[allRoom]
          this.markup.room= allRoom

        }
      
       

       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in onHotelChange",
          err.toString(),
          "onHotelChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSchedules(pIsDefaultActive) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSchedules");

        let lsWeekly = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        for (let i = 0; i < lsWeekly.length; i++) {
          let schedule = {
            value: lsWeekly[i],
            isActive: pIsDefaultActive,
          };
          retValue.push(schedule);
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MARKUP_NEW,
          "error in getSchedules",
          err.toString(),
          "getSchedules",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getHotelRooms(pHotel) {
      let retValue=[];
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelRooms");
        if (pHotel) {
          let hotelRoomsReq = apiGetHotelRooms.buildRequest(pHotel.hotelid);

          if (hotelRoomsReq) {
            let hotelRoomsRes = await apiGetHotelRooms.getResponse(
              hotelRoomsReq
            );

            if (VALIDATE_SUCCESS_RES(hotelRoomsRes)) {
              retValue = hotelRoomsRes.data.data.list;
             
            } else {
              let error = getErrorMessage(hotelRoomsRes);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in getHotelRooms",
          err.toString(),
          "getHotelRooms",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getallHotelss() {
      let returnValue;
      try {
        this.isShowAlertModal = false;
        if (BaseConfiguration.isDebug) console.log("getallHotelss");

        let allHotelsRequest = apiGetAllHotels.buildRequest();

        if (allHotelsRequest != null) {
          let allHotelsResponse = await apiGetAllHotels.getResponse(
            allHotelsRequest
          );
          if (VALIDATE_SUCCESS_RES(allHotelsResponse)) {
            returnValue = allHotelsResponse.data.data.list;

            returnValue.forEach((hotel) => {
              hotel["country"] = this.$options.filters.hmsCountryName(
                hotel.countryCode
              );
              hotel["city"] = this.$options.filters.hmsCityName(hotel.cityCode);
              if (hotel.supplierGroup)
                hotel.supplierName = hotel.supplierGroup.name;
              else hotel.supplierName = "";
            });
            this.SET_HOTEL_LS(returnValue);
          } else {
            let error = getErrorMessage(allHotelsResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              let alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in  get All Users",
          err.toString(),
          "getallHotelss",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getAllSupplierGroups() {
      let returnValue = [];
      try {
        this.isShowAlertModal = false;
        if (BaseConfiguration.isDebug) console.log("getAllSupplierGroups");

        let allSupplierGroupRequest = apiGetSupplierGroup.buildRequest();

        if (allSupplierGroupRequest) {
          let allSupplierGroupResponse = await apiGetSupplierGroup.getResponse(
            allSupplierGroupRequest
          );
          if (VALIDATE_SUCCESS_RES(allSupplierGroupResponse)) {
            returnValue = allSupplierGroupResponse.data.data.list;
            this.SET_SUPPLIER_GRP_LS(returnValue);

            this.alertValue = null;
          } else {
            let error = getErrorMessage(allSupplierGroupResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in  get All Users",
          err.toString(),
          "getAllSupplierGroups",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    getAppliDaysForReq(pSelAppliDays) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAppliDaysForReq");
        for (let i = 0; i < pSelAppliDays.length; i++) {
          retValue.push(pSelAppliDays[i].code);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in getAppliDaysForReq",
          err.toString(),
          "getAppliDaysForReq",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
      updateApplicableDays(pWeekDays) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateApplicableDays");

        if (pWeekDays && pWeekDays.length) {
          this.selApplicableDays=pWeekDays


        } else {
          this.selApplicableDays=[];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in updateApplicableDays",
          err.toString(),
          "updateApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async createHotelMarkup() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createHotelMarkup");
        // let applicableDays = cloneData(this.markup.applicableDays);
        // let applicableDays = this.markup.applicableDays;
        // this.markup.applicableDays = []
        // for (let i = 0; i < applicableDays.length; i++) {
        //   if(applicableDays[i].day){
        //   this.markup.applicableDays.push(applicableDays[i].day)
        //   }else{
        //     this.markup.applicableDays.push(applicableDays[i].value)
        //   }
          
        // }
        this.markup.applicableDays = this.selApplicableDays
        this.markup.from = formatDate( this.markup.from,DATE_TIME_FORMAT.API_DATE_FORMAT)
        this.markup.to = formatDate( this.markup.to,DATE_TIME_FORMAT.API_DATE_FORMAT)
        let createMarkupReq = apiCreateHotelMarkup.buildRequest(this.markup);

        if (createMarkupReq) {
          let createMarkupRes = await apiCreateHotelMarkup.getResponse(
           createMarkupReq
          );

          if (VALIDATE_SUCCESS_RES(createMarkupRes)) {
            this.alertValue = null;
            retValue = createMarkupRes.data.data;
             this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("markUpNew.addSuccess")
            );
          } else {
            let error = getErrorMessage(createMarkupRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in createHotelMarkup",
          err.toString(),
          "createHotelMarkup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

   async updateHotelMarkup() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelMarkup");
        // let applicableDays = cloneData(this.markup.applicableDays);
        // this.markup.applicableDays = []
        // for (let i = 0; i < applicableDays.length; i++) {
        //    if(applicableDays[i].day){
        //   this.markup.applicableDays.push(applicableDays[i].day)
        //   }else{
        //     this.markup.applicableDays.push(applicableDays[i].value)
        //   }
        // }
         this.markup.applicableDays = this.selApplicableDays
       
        this.markup.from = formatDate( this.markup.from,DATE_TIME_FORMAT.API_DATE_FORMAT)
        this.markup.to = formatDate( this.markup.to,DATE_TIME_FORMAT.API_DATE_FORMAT)
        let updateMarkupReq = apiUpdateHotelMarkup.buildRequest(this.markup,this.GET_SEL_MARKUP.markupid);

        if (updateMarkupReq) {
          let updateMarkupRes = await apiUpdateHotelMarkup.getResponse(
           updateMarkupReq
          );

          if (VALIDATE_SUCCESS_RES(updateMarkupRes)) {
            this.alertValue = null;
            retValue = updateMarkupRes.data.data;
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("markUpNew.updateSuccess")
            );
          } else {
            let error = getErrorMessage(updateMarkupRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in updateHotelMarkup",
          err.toString(),
          "updateHotelMarkup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.noBtn"),
            func: this.toggleShowAlertModal,
          },
          {
            name: this.$t("markUpNew.yesBtn"),
            func: this.GET_SEL_MARKUP
              ? this.updateHotelMarkup
              : this.createHotelMarkup,
          },
        ];
      } else if (
        status == ALERT_MODAL_STATUS.SUCCESS 
      ) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.okBtn"),
            func: this.navigateToAllMarkup,
          },
        ];
      }else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
      this.confirmTxt = val;
    },

    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    navigateToAllMarkup() {
        try {
          if(BaseConfiguration.isDebug) console.log("navigateToAllMarkup");
         navigate(PATHNAME.MARKUP_ALL)
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MARKUP_NEW,
                  "error in navigateToAllMarkup",
                  err.toString(),
                  "navigateToAllMarkup",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

   toSaveHotelMarkup() {
      try {
        if (BaseConfiguration.isDebug) console.log("toSaveHotelMarkup");
        
          this.GET_SEL_MARKUP
            ? this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                this.$t("markUpNew.updateConfirm")
              )
            : this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                this.$t("markUpNew.addConfirm")
              );
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in toSaveHotelMarkup",
          err.toString(),
          "toSaveHotelMarkup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignMarkupObj(pMarkupObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("assignMarkupObj");
           let allHotel ={hotelid:null,hotelName:DEFAULT_DROPDOWN_STATUS.ALL}
           let allRoom={roomid:null,roomname:DEFAULT_DROPDOWN_STATUS.ALL}

          this.markup.supplier = pMarkupObj.supplierGroup;
          this.onSupplierGroupChange(this.markup.supplier)
            if(pMarkupObj.hotel==null)
            {
              this.markup.hotel= allHotel
            }
            else
            {
          this.markup.hotel = pMarkupObj.hotel;
            }
          this.markup.isActive=pMarkupObj.isactive
          this.onHotelChange(this.markup.hotel)
           if(pMarkupObj.room==null) 
           {
        this.markup.room=allRoom
           }
           else{
          this.markup.room = pMarkupObj.room;
           }
          this.markup.from = pMarkupObj.stayfrom;
          this.markup.to = pMarkupObj.stayto;
          this.selCurrency = pMarkupObj.currency;
          for (let i = 0; i < this.valueTypes.length; i++) {
           if(this.valueTypes[i].code == pMarkupObj.pricingType){
             this.markup.valueType = this.valueTypes[i];
           }
            
          }

          this.selApplicableDays= pMarkupObj.applicableDays
          //this.assignSelApplicableDays(pMarkupObj);
          // this.lsWeekly = this.getSchedules(false);
          // if(pMarkupObj.applicableDays && pMarkupObj.applicableDays.length>0){
          //   let weeklyls = cloneData(this.lsWeekly)
          //   for (let i = 0; i < pMarkupObj.applicableDays.length; i++) {
          //     for (let j = 0; j < weeklyls.length; j++) {
          //       if (pMarkupObj.applicableDays[i] == weeklyls[j].value) {
          //         weeklyls[j].isActive = true;
          //       }
          //     }
          //   }
          //   this.lsWeekly = weeklyls;
          //   this.markup.applicableDays=[]
          //   for (let index = 0; index < this.lsWeekly.length; index++) {
          //     if(this.lsWeekly[index].isActive){
          //       this.markup.applicableDays.push(this.lsWeekly[index])
          //     }
              
          //   }
          // }
          this.markup.amount = pMarkupObj.markupvalue;
          // this.markup.applicableDays = pMarkupObj.applicableDays;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MARKUP_NEW,
                  "error in assignMarkupObj",
                  err.toString(),
                  "assignMarkupObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
        getLsApplicableDays() {
      try {
        if (BaseConfiguration.isDebug) console.log("getLsApplicableDays");

        for (
          let i = 0;
          i < Object.keys(this.GET_ALL_ENUMS.weekDays).length;
          i++
        ) {
          let dayObj = {
            code: Object.keys(this.GET_ALL_ENUMS.weekDays)[i],
            name: Object.values(this.GET_ALL_ENUMS.weekDays)[i]
          };
          this.lsWeekly.push(dayObj);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error in getLsApplicableDays",
          err.toString(),
          "getLsApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getHmsAllEnums() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHmsAllEnums");

        let getRoutesRequest = apiGetHmsAllEnums.buildRequest();

        if (getRoutesRequest) {
         
          let getRouteResponse = await apiGetHmsAllEnums.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            
            retValue = getRouteResponse.data.data;
            this.SET_ALL_ENUMS(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_NEW,
          "error while getting response from getHmsAllEnums API",
          err.toString(),
          "getHmsAllEnums",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      updateDataEdited(true);

     
      if(this.GET_ALL_ENUMS){
  //    this.getLsApplicableDays();
      }else{
        await this.getHmsAllEnums();
        // this.getLsApplicableDays();
      }
      // this.lsWeekly = this.getSchedules(true);
      // console.log(this.lsWeekly)
      // this.markup.applicableDays = this.lsWeekly
      if (this.GET_SUPPLIER_GRP_LS) {
        this.lsSupplierGroup = this.GET_SUPPLIER_GRP_LS;
      } else {
        this.lsSupplierGroup = await this.getAllSupplierGroups();
      }
      this.getValueTypes();
      this.markup.from  = this.$options.filters.formatDate(
          new Date(),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
      this.markup.to = this.$options.filters.formatDate(
          addDays(new Date(), 7),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
      if(this.GET_SEL_MARKUP){
        this.assignMarkupObj(this.GET_SEL_MARKUP);
      }
      else
      {
        this.selApplicableDays= ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
      }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.MARKUP_NEW,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.MARKUP_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>